export enum DatabaseViewType {
  Table = 'table',
  Map = 'map',
  Form = 'form',
  Timeline = 'timeline',
  Calendar = 'calendar',
  Kanban = 'kanban',
  IFrame = 'iframe',
  Gantt = 'gantt',
}
